import colors from "../utils/colors";
import DesktopHeader from "../components/defaultHeader/DesktopHeader";
import Heading from "../components/typography/Heading";
import Patient from "../features/patients";

const PatientsPage = () => {
  return (
    <>
      <DesktopHeader
        headerContent={
            <Heading>Patients</Heading>
        }
      />
      <div
        className="p-[30px] h-full w-full"
        style={{ backgroundColor: colors.lightGrey }}
      >
        <Patient />
      </div>
    </>
  );
};

export default PatientsPage;
